import React from 'lib/react';
import {
  EVBreadcrumbs, EVGrid, EVButton, EVTypography,
} from 'lib/components';
import PropTypes from 'prop-types';
import { Link } from 'lib/router';
import useMediaQuery from 'hooks/useMediaQuery';
import { useTranslation } from 'lib/translation';
import TitleHeaderStyles from './TitleHeaderStyles';

function TitleHeader(props) {
  const {
    title, finalBreadcrumb, breadcrumbLinks, hideOnMobile,
  } = props;
  const classes = TitleHeaderStyles({ breadcrumbLinks });
  const isMobile = useMediaQuery(640);
  const { t } = useTranslation();

  // #genai Opt-in escape hatch for routes whose mobile Figma has no blue hero (Phase 2
  // /billing-information/add-ach + /add-card, Figma 269:21887 / 269:21702 / 269:21589). The page
  // owns its own centered sub-header on mobile, so we collapse the global hero entirely.
  if (isMobile && hideOnMobile) return null;

  return (
    <EVGrid component="header" container direction="column" className={classes.titleHeader}>
      {(!isMobile) && breadcrumbLinks && breadcrumbLinks.length > 0 && (
      <EVBreadcrumbs aria-label="breadcrumb" className={classes.breadcrumbs}>
        {
          breadcrumbLinks.map(({ title: breadcrumbTitle, link }) => (
            <EVButton key={link} component={Link} to={link} className={classes.breadcrumbsLinks}>
              {t(breadcrumbTitle)}
            </EVButton>
          ))
        }
        <EVTypography>{t(finalBreadcrumb || title)}</EVTypography>
      </EVBreadcrumbs>
      )}
      <EVTypography variant="h1" className={classes.title}>{t(title)}</EVTypography>
    </EVGrid>
  );
}

TitleHeader.propTypes = {
  title: PropTypes.string.isRequired,
  breadcrumbLinks: PropTypes.arrayOf(PropTypes.shape()),
  finalBreadcrumb: PropTypes.string,
  hideOnMobile: PropTypes.bool,
};

TitleHeader.defaultProps = {
  breadcrumbLinks: [],
  finalBreadcrumb: '',
  hideOnMobile: false,
};

export default TitleHeader;
